import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms'
import { ActivatedRoute, Router, RouterModule } from '@angular/router'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { AuthUserService } from 'src/app/service/auth/auth-user.service'
import { DdcLoggerService } from 'src/app/service/log/ddc-logger.service'
import { passwordMatchValidator } from 'src/app/validators/password.validator'
import { DdcButtonROneComponent } from '../../shared/ddc/ddc-button-r-one/ddc-button-r-one.component'
import { DdcButtonSOneComponent } from '../../shared/ddc/ddc-button-s-one/ddc-button-s-one.component'
import { DdcTextGradientComponent } from '../../shared/ddc/ddc-text-gradient/ddc-text-gradient.component'
@Component({
  selector: 'ddc-reset-password',
  templateUrl: './ddc-reset-password.component.html',
  styleUrls: ['./ddc-reset-password.component.scss'],
  imports: [
    AngularMaterialsModules,
    CommonModule,
    RouterModule,
    DdcTextGradientComponent,
    DdcButtonSOneComponent,
    DdcButtonROneComponent,
    ReactiveFormsModule,
  ],
})
export class DdcResetPasswordComponent {
  _token: string
  _code: string
  _user_id: string

  _hide = true
  _hideConfirm = true
  _findAccError: string = ''
  _isResetPasswordBtnLoading = false
  _isResetSuccessful = false

  _submitBtnText = 'Reset'
  _pageCardTitle = 'Reset Password'
  _pageCardText = 'Enter your new password.'

  _passwordRegex = '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[-#_+]).{8,}'
  _minLength = 2
  _maxLength = 50

  _form = new FormGroup(
    {
      _password: new FormControl('', [
        Validators.required,
        Validators.maxLength(50),
        Validators.pattern(this._passwordRegex),
      ]),

      _confirmPassword: new FormControl('', [
        Validators.required,
        Validators.maxLength(50),
        Validators.pattern(this._passwordRegex),
      ]),
    },
    {
      validators: passwordMatchValidator,
    },
  )

  constructor(
    private logger: DdcLoggerService,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthUserService,
  ) {}

  ngOnInit(): void {
    // Get the token and code from the route parameters
    this._token = this.route.snapshot.paramMap.get('token')
    this._code = this.route.snapshot.paramMap.get('code')
    this._user_id = this.route.snapshot.paramMap.get('user_id')

    if (!this._token || !this._code || !this._user_id) {
      this.router.navigate(['/login'])
    }
  }

  get password(): any {
    return this._form.get('_password')
  }

  get confirmPassword(): any {
    return this._form.get('_confirmPassword')
  }

  reset_password(): void {
    this.logger.info('DdcResetPasswordComponent: reset_password()')

    this._isResetPasswordBtnLoading = true
    this._submitBtnText = 'Reseting password...'

    if (
      !this.password.value ||
      !this.confirmPassword.value ||
      this.password.value != this.confirmPassword.value
    ) {
      return
    }
    const credentials = {
      user_id: this._user_id,
      code: this._code,
      token: this._token,
    }
    this.authService.reset_password(credentials, this.password.value).subscribe((res: any) => {
      setTimeout(() => {
        this._pageCardTitle = 'Recovered!'
        this._pageCardText =
          'Password recovery was successful. Please go to login page again and try to login with the new password.'

        this._isResetSuccessful = true
        this._isResetPasswordBtnLoading = false
        this._submitBtnText = 'Reset'
      }, 2000) // two seconds
    })
  }
}
